// extracted by mini-css-extract-plugin
export default {"cls1":"m3Sr8g0dCvzM6lYP6gGh","cls2":"g23Hv8_LEdYefptd8LQr m3Sr8g0dCvzM6lYP6gGh"};